import { createSlice } from "@reduxjs/toolkit";
import saveProcessedReportsApi from "@custom/rtk-apis/report/saveProcessedReport";

const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const saveProcessedReportsSlice = createSlice({
  name: "saveProcessedReportsSlice",
  initialState,
  reducers: {revertStatus (state:any) { state.status = ""; }},
  extraReducers: (builder) => {
    console.log("----------", builder)
    builder
      .addCase(saveProcessedReportsApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(saveProcessedReportsApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(saveProcessedReportsApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default saveProcessedReportsSlice.reducer;
export const { revertStatus } = saveProcessedReportsSlice.actions;
